import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PageTitle from "shared/ui/PageTitle";
import CustomAccordion from "shared/ui/CustomAccordion";
import PriceTable from "../components/PriceTable";

const advantages = [
    {
        id: "1",
        title: "Aflați în detaliu nevoile fiecărui elev",
        content: "Prin testarea cu Brio veți afla lacunele fiecărui elev în parte și veți înțelege ce cunoștințe și " +
            "competențe din materia predată nu a reușit să-și însușească.",
    },
    {
        id: "2",
        title: "Creați o relație mai bună cu părinții",
        content: "Puteți oferi părinților o evaluare imparțială a nivelului unui copil. În plus, raportul vă poate ajuta" +
            " să îi ghidați în luarea deciziilor critice privind Evaluarea Națională sau Bacalaureatul.",
    },
    {
        id: "3",
        title: "Monitorizați evoluția elevilor și a claselor în timp",
        content: "Puteți testa elevii de-a lungul întregului an sau în momentele critice dinaintea examenelor. Iar " +
            "evoluția unui elev de la o testare la alta va fi evidențiată grafic în contul său Brio.",
    },
    {
        id: "4",
        title: "Salvați timp pierdut cu alcătuirea și corectura testelor",
        content: "Puteți înlocui cu succes lucrările de la clasă cu teste Brio. Fiecare elev va primi un test unic la " +
            "nivel de itemi, dar perfect egal ca grad de dificultate cu al colegilor săi. Toate rezultatele se pot " +
            "trimite și către profesori.",
    },
    {
        id: "5",
        title: "Identificați \"vârfurile\" și elevii foarte slab pregătiți",
        content: "Scorurile centilă din cadrul rapoartelor Brio vă arată cine poate face performanță și cine riscă să " +
            "rămână în urmă.",
    },
]

const AboutBrioTeachers = () => {

    return (
        <Box component="main">
            <PageTitle>
                BRIO pentru profesori
            </PageTitle>
            <Typography variant="body1">
                Testele Brio sunt teste digitale standardizate, adaptate la noile standarde naționale de evaluare
                (clasele I - VIII), prin care profesorii pot evalua obiectiv cunoștințele elevilor din clasele I-XII la
                principalele materii școlare, își pot personaliza relația educațională cu elevii și oferi direcții clare
                de gestionare a nivelului de pregătire al acestora.
            </Typography>
            <Typography variant="body1">
                Prin intermediul raportului Brio puteți ajuta părinții să înțeleagă exact care este situația copilului
                și cum trebuie să se implice și să colaboreze cu dumneavoastră.
            </Typography>

            <Typography variant="h3" mt={3} mb={3}>Identificați „vârfurile” și elevii slab pregătiți</Typography>
            <Typography variant="body1" mb={3}>
                Notele obținute în urma testării cu Brio vă arată cine poate face performanță și cine riscă să rămână în
                urmă.
            </Typography>
            {/*<CustomAccordion data={advantages}/>*/}

            <Typography variant="h3" mt={3} mb={3}>Raportul Brio®</Typography>
            <Typography variant="body1">
                Brio® oferă și evaluare, nu doar testare: după fiecare test vezi instant detaliile despre unde a greșit
                elevul sau ce nu a răspuns, precum și Raportul Brio®, care analizează în detaliu competențele elevului
                și oferă recomandări în legătură cu următorii pași de urmat.
            </Typography>
            <PriceTable/>
        </Box>
    )
}

export default AboutBrioTeachers;